module.exports = __webpack_public_path__ + "static/certificate-91f084b7d558e00f7dee5c23662da8d3.png";